import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _EmployeeBonus, _EmployeeIncapacity, _EmployeeNovelty } from '../../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';

interface Props {
    year: number;
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectElectronicPayrollIncapacitiesMonths = ({ year, idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_EmployeeIncapacity);
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector);
    }, [])

    useEffect(() => {
        if (year) {
            getLista();
        }
    }, [year])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(e);
        ////console.log(id)
    }

    const getLista = () => {
        instance.getElectronicPayrollIncapacitiesMonths(year).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(err => { toast.error(err) });
    }


    return (
        <>
            <label>{label ?? "Mes a Aplicar"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={""} >...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}